/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {DocumentState} from './report';
import {State} from './state';
import {History} from './history';
import { Stage } from './stage';

export class ReportNotification {
  ID: string;
  DATA: any;

  static parse(json: any): ReportNotification {
    if (json) {
      const h = new ReportNotification();

      h.ID = json.ID;

      if (json.DATA && json.DATA.TYPE) {
        const type = ReportNotificationType[<string>json.DATA.TYPE];

        if (type === ReportNotificationType.ENGAGED)
          h.DATA = ReportNotificationDataEngaged.parse(json.DATA);
      }

      return h;
    } else return null;
  }
}

export class ReportNotificationDataEngaged {
  TYPE: ReportNotificationType;
  STAGE: Stage;
  STATE: State;
  DATE_ENGAGED: Date;
  DATE_DUE: Date;
  DOCUMENT_STATE: DocumentState;
  HISTORY: History;

  static parse(json: any): ReportNotificationDataEngaged {
    if (json) {
      const h = new ReportNotificationDataEngaged();

      h.TYPE = ReportNotificationType[<string>json.TYPE];

      h.STAGE = Stage.parse(json.STAGE);
      h.STATE = State.parse(json.STATE);

      h.DATE_ENGAGED = json.DATE_ENGAGED;
      h.DATE_DUE = json.DATE_DUE;
      h.DOCUMENT_STATE = DocumentState[<string>json.DOCUMENT_STATE];
      h.HISTORY = History.parse(json.HISTORY);

      return h;
    } else return null;
  }
}

export enum ReportNotificationType {
  STAGE_CHANGED = 'STAGE_CHANGED',
  ENGAGED = 'ENGAGED'
}
